import { CommonModule } from '@angular/common';
import { Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-capital-button',
  imports: [CommonModule],
  templateUrl: './capital-button.html',
  styleUrl: './capital-button.scss',
})
export class CapitalButton {
  title = input<string>();
  subtitle = input<string>();
  icon = input<string>();

}
